/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Public_Create_Care_LogInputs */

const vi_grower_area_public_create_care_log = /** @type {(inputs: Grower_Area_Public_Create_Care_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo nhật ký chăm sóc`)
};

/**

* @param {Grower_Area_Public_Create_Care_LogInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_public_create_care_log = /** @type {((inputs?: Grower_Area_Public_Create_Care_LogInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Public_Create_Care_LogInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_public_create_care_log(inputs)
});